"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getInitialContext = () => ({
    appointment: undefined,
    appointmentId: undefined,
    cancelEmail: undefined,
    cancelEmailConsent: false,
    cancelReasonText: '',
    locationId: undefined,
    locations: [],
    providerId: undefined,
    provider: {},
    services: {
        cancelAppointment: () => {
            throw new Error('callback not defined');
        },
        getAppointment: () => {
            throw new Error('callback not defined');
        },
        getProvider: () => {
            throw new Error('callback not defined');
        }
    }
});
exports.default = getInitialContext;
//# sourceMappingURL=getInitialContext.js.map